import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { getRecentlySlugs } from "../../hooks/useRecentlyViewed";
import { getRecentlyViewedProducts } from "../../api/products";
import ProductCard from "../ProductCard";

import "swiper/css";
import "swiper/css/navigation";

const RecentlyViewed = ({ excludeSlug = null }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      const slugs = getRecentlySlugs().filter((s) => s !== excludeSlug);
      if (!slugs.length) return;

      setLoading(true);
      try {
        const res = await getRecentlyViewedProducts(slugs);
        if (res?.status === "ok") setProducts(res.products || []);
      } catch {
        // silent fail
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [excludeSlug]);

  if (!loading && products.length === 0) return null;

  return (
    <section className="flat-spacing-9">
      <div className="container">
        <div className="flat-title">
          <span className="title">Recently Viewed</span>
        </div>

        {loading ? (
          <div
            style={{ textAlign: "center", padding: "20px 0", color: "#888" }}
          >
            Loading...
          </div>
        ) : (
          <div className="wrap-carousel">
            <Swiper
              modules={[Navigation]}
              spaceBetween={15}
              slidesPerView={2}
              navigation={{
                nextEl: ".nav-prev-recently",
                prevEl: ".nav-next-recently",
              }}
              breakpoints={{
                640: { slidesPerView: 3, spaceBetween: 15 },
                1024: { slidesPerView: 4, spaceBetween: 30 },
              }}
              className="tf-sw-product-sell"
            >
              {products.map((product) => (
                <SwiperSlide key={product.id}>
                  <ProductCard product={product} setResponsiveGrid={false} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="nav-sw nav-next-slider nav-next-recently box-icon w_46 round">
              <span className="icon icon-arrow-left"></span>
            </div>
            <div className="nav-sw nav-prev-slider nav-prev-recently box-icon w_46 round">
              <span className="icon icon-arrow-right"></span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default RecentlyViewed;
